import React, { useEffect, useCallback } from "react";

import { Alert } from "reactstrap";

import "./Alerts.css";

const DEFAULT_TIMEOUT_MS = 10000;

const Alerts = ({ alerts, setAlerts }) => {
  const onDismissAlert = useCallback(
    (a) => {
      setAlerts((prev) => prev.filter((item) => item.id !== a.id));
    },
    [setAlerts]
  );

  useEffect(() => {
    const timers = alerts?.map((alert) => {
      const timeout = alert.timeout ?? DEFAULT_TIMEOUT_MS;
      return setTimeout(() => onDismissAlert(alert), timeout);
    }) || [];

    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, [alerts, onDismissAlert]);

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "90%",
        maxWidth: "600px",
        zIndex: 9999,
        pointerEvents: "auto",
      }}
    >
      {alerts?.map((alert) => (
        <Alert
          key={alert.id}
          color={alert.color}
          toggle={() => onDismissAlert(alert)}
          transition={{ timeout: 150 }}
          className="brand-alert"
        >
          {alert.message}
        </Alert>
      ))}
    </div>
  );
};

export default Alerts;
